import * as Yup from 'yup';

export const courseValidationSchema = Yup.object().shape({
  name: Yup.string()
    .min(3, 'The course name should be of minimum 3 characters length')
    .max(1000, 'The course name should be of maximum 1000 characters length')
    .required('Please enter the course name here')
    .matches(
      /^[A-Za-z0-9_-\s]+$/,
      'Course name can only include letters, numbers, and the following characters: - _'
    ),
  description: Yup.string(),
  start: Yup.date().typeError('Please enter a valid date').nullable(),
  end: Yup.date().typeError('Please enter a valid date').nullable(),
});
